import * as React from 'react';

import { Badge, Icon, Button, Tooltip } from '../index';

import { ResourceReaderFunction } from '@wyz/types';
import { FileObjectShape } from './dropzone-area-base';
import { isNil } from 'lodash-es';

type Props = {
  fileObjects: Array<FileObjectShape>;
  onRemove?: (index: number) => (event: React.MouseEvent) => void;
  resourceReader?: ResourceReaderFunction;
};

const ImagePreview = ({
  src,
  onClose,
}: {
  src: string;
  onClose: () => void;
}) => {
  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return (
    <div
      className='position-fixed p-2 d-flex align-items-center justify-content-center'
      style={{ inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1020 }}
    >
      <div
        className='position-fixed p-2'
        style={{ right: 0, top: 0, zIndex: 1021 }}
      >
        <Button id='close-preview' variant='white-chip' onClick={onClose}>
          <Icon icon='close' />
        </Button>
      </div>
      <img src={src} />
    </div>
  );
};

const PreviewList = ({
  fileObjects,
  onRemove,
  resourceReader,
}: React.PropsWithChildren<Props>) => {
  const [selectedForPreview, setSelectedForPreview] = React.useState<
    number | undefined
  >(undefined);
  return (
    <div className='grid gap-3 mt-2'>
      {fileObjects.map((fileObject, index) => {
        return (
          <Badge
            key={`${fileObject.file?.name ?? 'file'}-${index}`}
            as='div'
            bg='info'
            className='g-col-4 flex d-flex align-items-center position-relative'
          >
            <div className='controlled me-1'>
              <Icon icon='eye' size='xxs' />
            </div>
            {fileObject.resource &&
            !isNil(resourceReader) &&
            !fileObject.resource?.mimeType?.includes('image') ? (
              <a
                href={'#'}
                onClick={() => {
                  if (fileObject.resource)
                    resourceReader(fileObject.resource.id);
                }}
                target='_blank'
                rel='noreferrer'
                data-cy={`open-file-${fileObject.file?.name || 'NOOP'}`}
              >
                {fileObject.file?.name}
              </a>
            ) : (
              <Tooltip
                label={
                  fileObject.file?.name ?? fileObject.resource?.originalFileName
                }
              >
                <div
                  role='button'
                  onClick={() => setSelectedForPreview(index)}
                  className='text-truncate py-1 w-100 text-left'
                >
                  {fileObject.file?.name ??
                    fileObject.resource?.originalFileName ??
                    ''}
                </div>
              </Tooltip>
            )}
            {onRemove && (
              <div
                id='remove-file'
                className='position-absolute h-100 d-flex align-items-center justify-content-center btn btn-danger btn-xs btn btn-danger'
                role='button'
                style={{ left: '101%', top: 0 }}
                onClick={onRemove(index)}
              >
                <Icon icon='trash' />
              </div>
            )}
            {selectedForPreview === index ? (
              <ImagePreview
                src={
                  fileObject.resource
                    ? fileObject.resource.resourcesFormat[0].url
                    : fileObject.data
                }
                onClose={() => setSelectedForPreview(undefined)}
              />
            ) : undefined}
          </Badge>
        );
      })}
    </div>
  );
};

export default PreviewList;
